<template>
	<v-container class="pa-0">
		<!-- <CoolLightBox 
			:items="images.map((item) => {
				return {
					src: item.path,
					autoplay: true
				}
			})"
			:index="selectedImageIndex"
			:useZoomBar="true"
			@close="selectedImageIndex = null">
		</CoolLightBox> -->

    <GlobalFileViewer
      :media-items="mediaItems"
      :media-index="selectedImageIndex"
      :hide-open-morphable="true"
      :hide-minimize="true"
      @open-morphable="$emit('open-morphable', $event)"
      @close="selectedImageIndex = null"
      @onChange="onChangeImageIndex"
    />

		<div class="images-gallery-wrapper d-flex flex-row flex-wrap">
			<div
				class="image-gallery-item-container pa-1"
				v-for="(image, imageIndex) in mediaItems"
				:key="imageIndex"
			>
			<AudioRep :file="image.src" color="#2D4B95" downloadable flat small
				v-if="image.mime_type.includes('audio') || image.mime_type.includes('3gp')"></AudioRep>
			<div
				style="width: 100%; height: 100%"
				v-else
				@click="onMediaSelection(imageIndex)">
				<div class="video-container" v-if="image.mime_type.includes('video')">
					<video class="image-item" preload="metadata">
						<source :src="image.src" :type="image.mime_type">
					</video>
					<v-icon dark large color="#2D4B95" class="play-button">mdi-play</v-icon>
				</div>
				<div class="image-item"
					:style="{ backgroundImage: 'url(' + image.src + ')' }"
					v-else></div>
				</div>
			</div>
		</div>
	</v-container>
</template>

<script>
import AudioRep from '@/components/Globals/Helpers/AudioRep'
import GlobalFileViewer from '@/components/Globals/Helpers/GlobalFileViewer'

export default {
	name: 'MediaGallery',
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		mediaItems() {
			const mediaItems = this.items.filter(item => item.pathmedia).map((item) => {
				return {
					src: item.pathmedia.path,
					downloadable_url: item.downloadable_url,
					mime_type: item.mime_type,
					ext: item.ext,
					size: item.size,
					name: item.name,
					uid: item.uid,
					autoplay: true,
					item
				}
			})
			return mediaItems
		},
	},
	components: { AudioRep, GlobalFileViewer },
  data: () => ({
		selectedImageIndex: null,
	}),
	methods: {
		onMediaSelection(index) {
			this.selectedImageIndex = index
		},
		onChangeImageIndex(index) {
			this.selectedImageIndex = index
		}
	}
};
</script>

<style scoped>
	.content-container{
		overflow-y: scroll;
	}
	.image-gallery-item-container{
		height: 100px;
		width: 20%;
	}
	.image-item{
		width: 100%;
		height: 100%;
		cursor: pointer;
		object-fit: contain;
		background-size: contain;
    background-position: center;
    background-color: rgb(0 0 0 / 5%);
	}
	.video-container{
		width: 100%;
		height: 100%;
		position: relative;
		cursor: pointer;
	}
	.video-container .play-button{
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
</style>